import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * TODO: Remove this route after launch Corpdrivee
 * @deprecated Legacy route for Dostavkee
 * @see /dostavkee/orders
 */
export const Route = createFileRoute('/(redirects)/orders')({
    beforeLoad: async () => {
        throw redirect({ to: '/dostavkee/orders' })
    },
})
